import { KnowledgePiece } from '../../_types/knowledge.interface'
import { BuyHoldKnowledge } from './pages/buy-hold.knowledge'
import { SectorHeatersKnowlege } from './pages/sector-heaters.knowledge'
import { SwingKnowledge } from './pages/swing.knowledge'
import { AccountBalanceKnowledge } from './pieces/account-balance.knowledge'
import { SoundKnowledge } from './pieces/sound.knowledge'

const Knowledges: KnowledgePiece[] = [
  SectorHeatersKnowlege,
  SwingKnowledge,
  AccountBalanceKnowledge,
  BuyHoldKnowledge,
  SoundKnowledge
]

export default Knowledges
